<template>
  <section class="container">
    <div class="" style="margin:2% auto">
      <div class="columns">
        <div class="column is-full">
          <b-table :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition"
            v-if="provincialManagers" :data="isEmpty ? [] : provincialManagers" :bordered="true" :striped="true"
            :narrowed="true" :hoverable="true" :loading="isLoading" :focusable="true" :selected-sync="selected"
            :mobile-cards="true">

            <template slot-scope="props">
              <b-table-column field="name" label="Name">
                {{ props.row.name }}
              </b-table-column>

              <b-table-column field="email" label="Email">
                {{props.row.email}}
              </b-table-column>

              <b-table-column field="mobileNumber" label="Mobile Number">
                  {{ props.row.mobileNumber }}
              </b-table-column>

              <b-table-column field="action" label="Action">
                <b-tooltip label="Edit">
                  <button class="button is-primary " @click="openEditProvincialManagerModal(props.row)">
                    <b-icon icon="pencil" size="is-small">
                    </b-icon>
                  </button>
                </b-tooltip>
                <b-tooltip class=" is-danger " label="Delete">
                  <button class="button is-danger " @click="openDeleteProvincialManagerModal(props.row)">
                    <b-icon icon="delete" size="is-small">
                    </b-icon>
                  </button>
                </b-tooltip>
              </b-table-column>
              <!-- <b-table-column field="id" label="Product ID">
                {{ props.row.id }}
              </b-table-column> -->
            </template>

            <template slot="empty" v-if="!isLoading && provincialManagers.length == 0">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large">
                    </b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import decode from 'jwt-decode';
  import {ls} from '@/helpers'
  const EditUserModal = () => import('@/components/Users/EditUserModal');
  const DeleteUserModal = () => import('@/components/Users/DeleteUserModal');
  import {
    ucFirst
  } from '@/helpers';
  import {
    mapActions
  } from 'vuex';

  export default {
    name: "ProvincialManagers",
    data() {
      return {
        isPaginated: true,
        isPaginationSimple: false,
        paginationPosition: 'bottom',
        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        currentPage: 1,
        perPage: 50,
        isLoading: false,
        selected: [],
        provincialManagers: [],
      }
    },
    computed: {
      isEmpty() {
        return this.isLoading == true && this.equipmentTypes.filter(pT => pT.id == this.currentEquipmentType)[0].products
          .length == 0;
      },
      isProvincialManager() {
        return decode(ls('token')).user.type == "provincial-manager";
      }
    },
    created() {
      this.getProvincialManagers()
    },
    methods: {
      ...mapActions([
        'editProduct'
      ]),
      getProvincialManagers() {
        const loading = this.$loading.open();
        this.$store.dispatch('getUsers', {
          type: 'provincial-manager'
        }).then(({meta, users: provincialManagers}) => {
          loading.close()
          if (provincialManagers && provincialManagers.length > 0) {
            this.provincialManagers = provincialManagers;
          }
        }).catch(e => {
          loading.close()
          console.log('Exception when getting provincial managers', e);
          this.$toasted.global.error('Failed to get provincial managers.');
        })
      },
      openEditProvincialManagerModal(user) {
        this.$modal.open({
          component: EditUserModal,
          parent: this,
          props: {
            user
          },
          events: {
            closeModal: () => {
              this.getProvincialManagers();
            }
          }
        })
      },
      openDeleteProvincialManagerModal(user) {
        this.$modal.open({
          component: DeleteUserModal,
          parent: this,
          props: {
            user
          },
          events: {
            reload: () => {
              this.getProvincialManagers();
            }
          }
        })
      },
      async setProductAvailability(product) {
        try {
          await this.editProduct({ id: product.id, available: product.available });
          this.$toasted.global.success(`Product ${product.available === "true" ? 'now Available!' : 'Nolonger available.'}.`);
        } catch (e) {
          this.getEquipmentByType(this.currentEquipmentType);
          console.log(`Exception when updating product availability, e: ${e}`);
          this.$toasted.global.error(`Failed to update product.`)
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/ProvincialManagers/ProvincialManagers.vue